import React from 'react'
import { IconText } from 'app/components/icons'
import Assets from 'app/configs/assetConfigs'
import {
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'

export const NOTI_PRIORITY_HIGH_ITEM = {
  id: NOTI_PRIORITY_HIGH.id,
  display: (
    <IconText
      imgSrc={Assets.notiPriority.important}
      labelId="createNotification.dialog.notiPriority.high"
      additionalTextCls="mt-1"
    />
  ),
}

export const NOTI_PRIORITY_LOW_ITEM = {
  id: NOTI_PRIORITY_LOW.id,
  display: (
    <IconText
      imgSrc={Assets.notiPriority.information}
      labelId="createNotification.dialog.notiPriority.low"
      additionalTextCls="mt-1"
    />
  ),
}

export const NOTI_PRIORITY_URGENT_ITEM = {
  id: NOTI_PRIORITY_URGENT.id,
  display: (
    <IconText
      imgSrc={Assets.notiPriority.urgent}
      labelId="createNotification.dialog.notiPriority.urgent"
      additionalTextCls="mt-1"
      additionalImageCls="w-16 h-16 mx-1"
    />
  ),
}

export const NOTI_PRIORITY_EMERGENCY_ITEM = {
  id: NOTI_PRIORITY_EMERGENCY.id,
  display: (
    <IconText
      imgSrc={Assets.notiPriority.emergency}
      labelId="createNotification.dialog.notiPriority.emergency"
      additionalTextCls="mt-1"
      additionalImageCls="w-16 h-16 mx-1"
    />
  ),
}

export const priorityList = (emergency) => {
  return emergency
    ? [
        NOTI_PRIORITY_LOW_ITEM,
        NOTI_PRIORITY_HIGH_ITEM,
        NOTI_PRIORITY_URGENT_ITEM,
        NOTI_PRIORITY_EMERGENCY_ITEM,
      ]
    : [
        NOTI_PRIORITY_LOW_ITEM,
        NOTI_PRIORITY_HIGH_ITEM,
        NOTI_PRIORITY_URGENT_ITEM,
      ]
}
